module.exports = __webpack_public_path__ + "img/Panels-X-Black.502e278f.svg";